/** Shared helpers for Brand & Pages / Navigation public route pickers. */

export const CUSTOM_PATH = "__custom__";
export const CUSTOM_LABEL = "__custom_label__";

export function groupRoutes(routes) {
  const order = ["Pages", "Services", "Blog", "Legal", "Other"];
  const map = {};
  for (const r of routes || []) {
    const g = r.group || "Other";
    if (!map[g]) map[g] = [];
    map[g].push(r);
  }
  return order.filter((g) => map[g]?.length).map((g) => ({ group: g, items: map[g] }));
}

export function uniqueLabelRoutes(routes) {
  const seen = new Set();
  const out = [];
  for (const r of routes || []) {
    const key = (r.label || "").trim().toLowerCase();
    if (!key || seen.has(key)) continue;
    seen.add(key);
    out.push(r);
  }
  return out;
}

export function pathKey(url) {
  return String(url || "").trim().split("?")[0].split("#")[0];
}
